export const STUDENT_FIELDS_MAPPING = [
    { title: 'Legal Name', value: 'LegalName', readonly: true },
    { title: 'Preferred Name', value: 'PreferredName' },
    { title: 'Profile Status', value: 'ProfileStatus' },
    { title: 'Sex', value: 'Sex' },
    { title: 'Boarder Status', value: 'BoarderStatus' },
    { title: 'School Groups', value: 'SchoolGroups' },
    { title: 'Parent Contact 1', value: 'ParentContact1' },
    { title: 'Parent Contact 2', value: 'ParentContact2' },
    { title: 'OTC Medicine', value: 'OtcMedicine' },
    { title: 'SEN Status', value: 'SenStatus' },
    { title: 'SEN - Code K List', value: 'Sen' },
    { title: 'Dietary Requirements', value: 'DietaryRequirements' },
    { title: 'Welfare', value: 'Welfare' },
    { title: 'Pupil Premium and YC', value: 'FreeSchoolMeals' },
    { title: 'Ethnicity', value: 'Ethnicity' },
    { title: 'First language', value: 'FirstLanguageExposedTo' },
    { title: 'Speaks English', value: 'SpeaksEnglish' },
    { title: 'Birth Country', value: 'BirthCountry' },
    { title: 'Religion', value: 'Religion' },
    { title: 'Home language', value: 'LanguageSpokenAtHome' },
    { title: 'Asylum Status', value: 'AsylumStatus' },
    { title: 'Nationality', value: 'Nationality' },
    { title: 'Consents', value: 'Consents' },
    { title: 'Travel Options', value: 'TravelOptions' },
    { title: 'Year Group', value: 'YearGroup' },
    { title: 'Form', value: 'Form' },
    { title: 'House', value: 'House' },
    { title: 'Intake Group', value: 'IntakeGroup' },
    { title: 'Application Status', value: 'ApplicationStatus' },
    { title: 'Admissions Categories', value: 'AdmissionCategories' },
    { title: 'UPN', value: 'Upn' },
    { title: 'Previous School Name', value: 'PreviousSchoolName' },
    { title: 'Previous School Email', value: 'PreviousSchoolEmail' },
    { title: 'Date of Birth', value: 'DateOfBirth' },
    { title: 'Medical Conditions', value: 'MedicalConditions' },
    { title: 'Address', value: 'Address' },
    { title: 'Postcode', value: 'Postcode' },
];

export const EMPLOYEE_FIELDS_MAPPING = [
    { title: 'Legal Name', value: 'LegalName', readonly: true },
    { title: 'Preferred Name', value: 'PreferredName' },
    { title: 'Title', value: 'Title' },
    { title: 'Date of Birth', value: 'DateOfBirth' },
    { title: 'Email Address', value: 'Email' },
    { title: 'Mobile Number', value: 'MobileNumber' },
    { title: 'NI Number', value: 'NINumber' },
    { title: 'Bank Details', value: 'BankDetails' },
    { title: 'Address', value: 'HomeAddress' },
    { title: 'Postcode', value: 'Postcode' },
    { title: 'Car Details', value: 'CarDetails' },
    { title: 'Next of Kin', value: 'NextOfKin' },
    { title: 'Contacts', value: 'Contacts' },
];